var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBootstrapWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 562,
    height: 447.9,
    viewBox: "0 0 562 447.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bootstrap-white",
    d: "M333.5,201.4c0-22.1-15.6-34.3-43-34.3H240.1v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4ZM517,188.6c-9.5-30.9-10.9-68.8-9.8-98.1C508.3,60,484.5,32,452.5,32H123.7C91.6,32,67.9,60.1,69,90.5c1,29.3-.3,67.2-9.8,98.1-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1,9.5,30.9,10.9,68.8,9.8,98.1-1.1,30.5,22.7,58.5,54.7,58.5H452.4c32.1,0,55.8-28.1,54.7-58.5-1-29.3.3-67.2,9.8-98.1,9.6-31,25.7-50.6,52.1-53.1V241.7C542.7,239.2,526.5,219.6,517,188.6ZM300.2,375.1H202.3V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4,0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3C383.4,349.7,352.1,375.1,300.2,375.1Zm-10-108.7H240.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5C344.7,279.6,326.1,266.4,290.2,266.4Z",
    transform: "translate(-7 -32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrapWhite);
export default __webpack_public_path__ + "static/media/bootstrap-white.9e0fdf9b457a2656aa4e63e4f5563c10.svg";
export { ForwardRef as ReactComponent };